export function StatusBadge({ status }: { status: string }) {
  const isProcessed = status === 'processed'
  const isFailed = status === 'failed'
  const accentBg = isProcessed
    ? 'var(--success-surface)'
    : isFailed
      ? 'var(--destructive-surface)'
      : 'var(--card)'
  const accentColor = isProcessed
    ? 'var(--success)'
    : isFailed
      ? 'var(--destructive)'
      : 'var(--foreground)'
  const accentBorder = isProcessed
    ? '1px solid var(--success)'
    : isFailed
      ? '1px solid var(--destructive)'
      : '1px solid var(--border)'
  const accented = isProcessed || isFailed
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '2px 8px',
        borderRadius: '6px',
        fontSize: 11,
        fontWeight: accented ? 600 : 500,
        fontFamily: accented ? 'var(--font-mono)' : 'inherit',
        letterSpacing: accented ? 1 : 0,
        textTransform: accented ? 'uppercase' : 'none',
        background: accentBg,
        color: accentColor,
        border: accentBorder,
      }}
    >
      {status}
    </span>
  )
}
